
const routes = [
  {
    path: "/scheduler-page",
    name: "SchedulerPage",
    component: () => import(/* webpackChunkName: "SchedulerPage" */ "./views/SchedulerPage"),
    props: route => {
      const res = {}
      for (const key in route.query) {
        res[key] = route.query[key] === 'undefined' ? '' : route.query[key]
      }
      return res
    },

  }
];

export default routes;
